import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/"); return; }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState(null, "", "/account");
        navigate("/account", { state: { user: res.data } });
      } catch (e) {
        setError(true);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4" data-testid="auth-callback">
      {!error ? (
        <>
          <Loader2 className="h-10 w-10 animate-spin text-primary" />
          <p className="font-serif text-lg text-muted-foreground">Receiving your blessings…</p>
        </>
      ) : (
        <>
          <p className="font-serif text-xl">Sign-in could not be completed.</p>
          <button className="text-primary underline" onClick={() => navigate("/")}>Return home</button>
        </>
      )}
    </div>
  );
}
